<template>
  <div style="width: 100%">
    <div class="SInput " :class="{'InputError':error}" >
      <div class="u-flex u-row-between" v-if="list.length == 0">
        <div>{{ placeholder }}</div>
        <div>
          <Icon
            v-if="!iconvisible"
            color="#808695"
            class="ivu-select-arrow"
            type="ios-arrow-down"
          />

          <Icon
            v-else
            color="#808695"
            class="ivu-select-arrow"
            type="ios-arrow-up"
          />
        </div>
      </div>
      <div class="u-flex u-row-between" v-else>
        <div class="u-flex">
          <img :src="list[0]" class="draw-icon" />
          <img :src="list[1]" class="draw-icon" />
          <img :src="list[2]" class="draw-icon" />
        </div>
        <div>
          <Icon
            v-if="!iconvisible"
            color="#808695"
            class="ivu-select-arrow"
            type="ios-arrow-down"
          />

          <Icon
            v-else
            color="#808695"
            class="ivu-select-arrow"
            type="ios-arrow-up"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    formData: {},
    iconvisible: {},
  },
  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler: function (data) {
        const { iconNormalFullPath, iconAbnormalFullPath, iconAlarmFullPath } =
          data;

        if (iconNormalFullPath) {
          this.list = [
            iconNormalFullPath,
            iconAbnormalFullPath,
            iconAlarmFullPath,
          ];
        } else {
          this.list = [];
        }
      },
    },
  },
  data() {
    return {
      list: [],
      error: false,
    };
  },
  methods: {
    rest() {
      this.list = [];
    },
  },
};
</script>
<style lang="less" scoped>
.SInput {
  display: inline-block;
  width: 100%;
  // min-width: 400px;
  min-height: 32px;
  line-height: 1.5;
  padding: 4px 7px;
  font-size: 14px;
  border: 1px solid #dcdee2;
  // border-radius: 4px;

  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
  transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
  color: #c5c8ce;
  cursor: pointer;
  &:hover {
    border: 1px solid #3d6cb1;
    box-shadow: 0 0 0 2px rgba(12, 71, 157, 0.2);
  }
}
.draw-icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.InputError {
  border: 1px solid #ed4014;
 
  
}
</style>